import axios from 'axios';

/**
 * Public axios instance for unauthenticated API calls.
 *
 * Use this for:
 * - Registration endpoints
 * - Public category endpoints
 * - Password reset endpoints
 * - Any endpoint that doesn't require authentication
 *
 * This instance:
 * - Does NOT include auth interceptors
 * - Does NOT redirect on 401 errors
 * - Handles errors gracefully for public pages
 */
const publicAxios = axios.create({
  baseURL: process.env.REACT_APP_SERVER_URL,
  withCredentials: false, // No cookies/auth for public endpoints
  headers: {
    'Content-Type': 'application/json',
  },
});

// No auth interceptors - let components handle their own error states
export default publicAxios;
